// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Avatar-cls1___827eebd7084c4d88ad4{/*!*/}.Avatar-cls2___3f09f086205c0446cc2{--size: 40px;display:grid;height:var(--size);place-items:center;width:var(--size)}.Avatar-cls2___3f09f086205c0446cc2:focus-visible{outline:none}.Avatar-cls2___3f09f086205c0446cc2:focus-visible img{outline:medium none invert;outline:initial}.Avatar-cls2___3f09f086205c0446cc2.Avatar-small___0d99bf31a1da8fb4024{--size: 24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Avatar-cls1___827eebd7084c4d88ad4",
	"cls2": "Avatar-cls2___3f09f086205c0446cc2 Avatar-cls1___827eebd7084c4d88ad4",
	"small": "Avatar-small___0d99bf31a1da8fb4024"
};
export default ___CSS_LOADER_EXPORT___;
